/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountId,
  EmailChangeRequestDto,
  FrontendEventRequest,
  GuestStateRequestDto,
  InboxDescribeRoomResponseDto,
  InboxManagementRequestDto,
  InboxReassignRequestDto,
  LocationSettingsResponseDto,
  MapString,
  MapStringGuestStateResponseDto,
  MeetingOrigin,
  PaginatedResultSessionLogEntry,
  PlaybookStatsRequest,
  PlaybookStatsResponse,
  PrepareChatRequestDto,
  PrepareChatResponseDto,
  PrivateAndTenantUsers,
  PrivateAndWorkspaceUsers,
  ReportingTimeline,
  SelectPlaybookWithConversationRequestDto,
  SelectPlaybookWithConversationResponseDto,
  SessionLog,
  SessionsSummary,
  UserDescribeRoomsRequestDto,
  UserDescribeRoomsResponseDto,
  UserStatsRequest,
  UserStatsResponse,
  WidgetAppearanceSettings,
  WorkspaceSettings,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "chat-platform-chat";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Find playbook location settings data related to WorkspaceId for all enabled and working hours complient playbooks
   *
   * @tags chat-widget
   * @name GetApiV1PublicTenantTenantidWorkspacesWorkspaceidLocationSettings
   * @summary Find active LocationSettings for WorkspaceId
   * @request GET:/v1/public/tenant/{tenantId}/workspaces/{workspaceId}/location-settings
   */
  getApiV1PublicTenantTenantidWorkspacesWorkspaceidLocationSettings = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format uuid */
      guestId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      LocationSettingsResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/location-settings`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1PublicTenantTenantidWorkspacesWorkspaceidLocationSettings */
  getApiV1PublicTenantTenantidWorkspacesWorkspaceidLocationSettingsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format uuid */
      guestId: string;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/location-settings`, query);

  /**
   * @description Applies all rules configured and selects the one with highest priority and returns initial conversation
   *
   * @tags chat-widget
   * @name PutApiV1PublicTenantTenantidWorkspacesWorkspaceidPlaybooksSelectWithConversation
   * @summary Select active playbook with initial conversation
   * @request PUT:/v1/public/tenant/{tenantId}/workspaces/{workspaceId}/playbooks-select-with-conversation
   */
  putApiV1PublicTenantTenantidWorkspacesWorkspaceidPlaybooksSelectWithConversation = (
    tenantId: string,
    workspaceId: string,
    data: SelectPlaybookWithConversationRequestDto,
    query?: {
      /** @default false */
      forceStartNextSession?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SelectPlaybookWithConversationResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/playbooks-select-with-conversation`,
      method: "PUT",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1PublicTenantTenantidWorkspacesWorkspaceidPlaybooksSelectWithConversation */
  putApiV1PublicTenantTenantidWorkspacesWorkspaceidPlaybooksSelectWithConversationPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @default false */
      forceStartNextSession?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/playbooks-select-with-conversation`,
      query,
    );

  /**
   * No description
   *
   * @tags chat-widget
   * @name PutApiV1PublicTenantTenantidWorkspacesWorkspaceidPrepareChat
   * @summary Prepare chat
   * @request PUT:/v1/public/tenant/{tenantId}/workspaces/{workspaceId}/prepare-chat
   */
  putApiV1PublicTenantTenantidWorkspacesWorkspaceidPrepareChat = (
    tenantId: string,
    workspaceId: string,
    data: PrepareChatRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<
      PrepareChatResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/prepare-chat`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1PublicTenantTenantidWorkspacesWorkspaceidPrepareChat */
  putApiV1PublicTenantTenantidWorkspacesWorkspaceidPrepareChatPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/prepare-chat`);

  /**
   * @description Returns the latest widget appearance settings object if there is such, NotFound otherwise
   *
   * @tags chat-widget
   * @name GetApiV1PublicTenantTenantidWorkspacesWorkspaceidWidgetAppearance
   * @summary Get widget appearance settings for workspace
   * @request GET:/v1/public/tenant/{tenantId}/workspaces/{workspaceId}/widget/appearance
   */
  getApiV1PublicTenantTenantidWorkspacesWorkspaceidWidgetAppearance = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      WidgetAppearanceSettings,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1PublicTenantTenantidWorkspacesWorkspaceidWidgetAppearance */
  getApiV1PublicTenantTenantidWorkspacesWorkspaceidWidgetAppearancePathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`);

  /**
   * @description Returns the latest workspace settings object if there is such, NotFound otherwise
   *
   * @tags workspace-settings
   * @name GetApiV1PublicTenantTenantidWorkspacesWorkspaceidSettings
   * @summary Get workspace settings for workspace
   * @request GET:/v1/public/tenant/{tenantId}/workspaces/{workspaceId}/settings
   */
  getApiV1PublicTenantTenantidWorkspacesWorkspaceidSettings = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceSettings,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/settings`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1PublicTenantTenantidWorkspacesWorkspaceidSettings */
  getApiV1PublicTenantTenantidWorkspacesWorkspaceidSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/workspaces/${workspaceId}/settings`);

  /**
   * No description
   *
   * @tags inbox
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidInboxSetup
   * @summary Self-setup XMPP user for workspace-wide public and private chat
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/inbox/setup
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidInboxSetup = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PrivateAndWorkspaceUsers,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/inbox/setup`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidInboxSetup */
  postApiV1TenantTenantidWorkspacesWorkspaceidInboxSetupPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/inbox/setup`);

  /**
   * No description
   *
   * @tags inbox
   * @name PostApiV1TenantTenantidInboxSetup
   * @summary Self-setup XMPP user for private chat and tenant-wide public chat
   * @request POST:/v1/tenant/{tenantId}/inbox/setup
   * @secure
   */
  postApiV1TenantTenantidInboxSetup = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      PrivateAndTenantUsers,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/inbox/setup`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidInboxSetup */
  postApiV1TenantTenantidInboxSetupPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/inbox/setup`);

  /**
   * No description
   *
   * @tags inbox
   * @name PostApiV1TenantTenantidInboxReassign
   * @summary Reassign assignee to a different one
   * @request POST:/v1/tenant/{tenantId}/inbox/reassign
   * @secure
   */
  postApiV1TenantTenantidInboxReassign = (
    tenantId: string,
    data: InboxReassignRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/inbox/reassign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidInboxReassign */
  postApiV1TenantTenantidInboxReassignPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/inbox/reassign`);

  /**
   * No description
   *
   * @tags inbox
   * @name PutApiV1TenantTenantidInboxManage
   * @summary Close/Open Inbox conversation. This will move convos to a particular box depending on payload for all xmpp accounts related to the guest
   * @request PUT:/v1/tenant/{tenantId}/inbox/manage
   * @secure
   */
  putApiV1TenantTenantidInboxManage = (tenantId: string, data: InboxManagementRequestDto, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/inbox/manage`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidInboxManage */
  putApiV1TenantTenantidInboxManagePathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/inbox/manage`);

  /**
   * No description
   *
   * @tags inbox
   * @name GetApiV1TenantTenantidRoomRoomjidDescribe
   * @summary Provide room related data
   * @request GET:/v1/tenant/{tenantId}/room/{roomJid}/describe
   * @secure
   */
  getApiV1TenantTenantidRoomRoomjidDescribe = (tenantId: string, roomJid: string, params: RequestParams = {}) =>
    this.request<
      InboxDescribeRoomResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/room/${roomJid}/describe`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidRoomRoomjidDescribe */
  getApiV1TenantTenantidRoomRoomjidDescribePathGetter = (tenantId: string, roomJid: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/room/${roomJid}/describe`);

  /**
   * No description
   *
   * @tags inbox
   * @name GetApiV1TenantTenantidRoomsDescribeDetails
   * @summary Get user specific data about rooms
   * @request GET:/v1/tenant/{tenantId}/rooms/describe/details
   * @secure
   */
  getApiV1TenantTenantidRoomsDescribeDetails = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      roomJid: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UserDescribeRoomsResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rooms/describe/details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidRoomsDescribeDetails */
  getApiV1TenantTenantidRoomsDescribeDetailsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      roomJid: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rooms/describe/details`, query);

  /**
   * No description
   *
   * @tags inbox
   * @name PostApiV1TenantTenantidRoomsDescribeDetails
   * @summary Get user specific data about rooms with POST
   * @request POST:/v1/tenant/{tenantId}/rooms/describe/details
   * @secure
   */
  postApiV1TenantTenantidRoomsDescribeDetails = (
    tenantId: string,
    data: UserDescribeRoomsRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<
      UserDescribeRoomsResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rooms/describe/details`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidRoomsDescribeDetails */
  postApiV1TenantTenantidRoomsDescribeDetailsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/rooms/describe/details`);

  /**
   * No description
   *
   * @tags guest-state-management
   * @name GetApiV1TenantTenantidGuestState
   * @summary Get guest state
   * @request GET:/v1/tenant/{tenantId}/guest/state
   * @secure
   */
  getApiV1TenantTenantidGuestState = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      guestIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapStringGuestStateResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/guest/state`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidGuestState */
  getApiV1TenantTenantidGuestStatePathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      guestIds: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/guest/state`, query);

  /**
   * @description Replaces the whole guest state Map with provided values. Metadata for unchanged values won't be updated.
   *
   * @tags guest-state-management
   * @name PutApiV1TenantTenantidGuestGuestidState
   * @summary Replace guest state
   * @request PUT:/v1/tenant/{tenantId}/guest/{guestId}/state
   * @secure
   */
  putApiV1TenantTenantidGuestGuestidState = (
    tenantId: string,
    guestId: string,
    data: GuestStateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/guest/${guestId}/state`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidGuestGuestidState */
  putApiV1TenantTenantidGuestGuestidStatePathGetter = (tenantId: string, guestId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/guest/${guestId}/state`);

  /**
   * @description Syncs guest state with the latest data from the source, not waiting for timeout
   *
   * @tags guest-state-management
   * @name PutApiV1TenantTenantidGuestGuestidStateSyncNow
   * @summary Sync guest state immediately
   * @request PUT:/v1/tenant/{tenantId}/guest/{guestId}/state-sync-now
   * @secure
   */
  putApiV1TenantTenantidGuestGuestidStateSyncNow = (tenantId: string, guestId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/guest/${guestId}/state-sync-now`,
      method: "PUT",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidGuestGuestidStateSyncNow */
  putApiV1TenantTenantidGuestGuestidStateSyncNowPathGetter = (tenantId: string, guestId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/guest/${guestId}/state-sync-now`);

  /**
   * @description This change is never applied in scope of guest state udpate, as email change breaks consistency
   *
   * @tags guest-state-management
   * @name PutApiV1TenantTenantidGuestGuestidChangeEmail
   * @summary Change guest email
   * @request PUT:/v1/tenant/{tenantId}/guest/{guestId}/change-email
   * @secure
   */
  putApiV1TenantTenantidGuestGuestidChangeEmail = (
    tenantId: string,
    guestId: string,
    data: EmailChangeRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/guest/${guestId}/change-email`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidGuestGuestidChangeEmail */
  putApiV1TenantTenantidGuestGuestidChangeEmailPathGetter = (tenantId: string, guestId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/guest/${guestId}/change-email`);

  /**
   * @description Collects frontend event about user (POC, might get removed)
   *
   * @tags reporting
   * @name PostApiV1PublicTenantTenantidReportingCollect
   * @summary Collects event (POC, might get removed)
   * @request POST:/v1/public/tenant/{tenantId}/reporting/collect
   */
  postApiV1PublicTenantTenantidReportingCollect = (
    tenantId: string,
    query: {
      /** @format uuid */
      guestId: string;
    },
    data: FrontendEventRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/reporting/collect`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1PublicTenantTenantidReportingCollect */
  postApiV1PublicTenantTenantidReportingCollectPathGetter = (
    tenantId: string,
    query: {
      /** @format uuid */
      guestId: string;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/reporting/collect`, query);

  /**
   * @description Gather timeline
   *
   * @tags reporting
   * @name PostApiV1TenantTenantidGuestGuestidTimeline
   * @summary Gather timeline
   * @request POST:/v1/tenant/{tenantId}/guest/{guestId}/timeline
   * @secure
   */
  postApiV1TenantTenantidGuestGuestidTimeline = (tenantId: string, guestId: string, params: RequestParams = {}) =>
    this.request<
      ReportingTimeline,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/guest/${guestId}/timeline`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidGuestGuestidTimeline */
  postApiV1TenantTenantidGuestGuestidTimelinePathGetter = (tenantId: string, guestId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/guest/${guestId}/timeline`);

  /**
   * @description Gather user stats
   *
   * @tags reporting
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidReportingUserStats
   * @summary Gather user stats
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/reporting/user-stats
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidReportingUserStats = (
    tenantId: string,
    workspaceId: string,
    data: UserStatsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      UserStatsResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/reporting/user-stats`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidReportingUserStats */
  postApiV1TenantTenantidWorkspacesWorkspaceidReportingUserStatsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/reporting/user-stats`);

  /**
   * @description Gather playbook stats
   *
   * @tags reporting
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidReportingPlaybookStats
   * @summary Gather playbook stats
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/reporting/playbook-stats
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidReportingPlaybookStats = (
    tenantId: string,
    workspaceId: string,
    data: PlaybookStatsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookStatsResponse,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/reporting/playbook-stats`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidReportingPlaybookStats */
  postApiV1TenantTenantidWorkspacesWorkspaceidReportingPlaybookStatsPathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/reporting/playbook-stats`);

  /**
   * @description Get chat sessions list
   *
   * @tags logs
   * @name GetSessionLogsList
   * @summary Get chat sessions list
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/logs/sessions-list
   * @secure
   */
  getSessionLogsList = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to?: string;
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
      email?: string;
      playbookIds?: string[];
      conversationAssigneeIds?: string[];
      meetingAssigneeIds?: string[];
      targetedUrl?: string;
      respondedUrl?: string;
      meetingOrigin?: MeetingOrigin;
      livechatRouted?: boolean;
      repJoined?: boolean;
      hasErrors?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSessionLogEntry,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logs/sessions-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSessionLogsList */
  getSessionLogsListPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to?: string;
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
      email?: string;
      playbookIds?: string[];
      conversationAssigneeIds?: string[];
      meetingAssigneeIds?: string[];
      targetedUrl?: string;
      respondedUrl?: string;
      meetingOrigin?: MeetingOrigin;
      livechatRouted?: boolean;
      repJoined?: boolean;
      hasErrors?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logs/sessions-list`, query);

  /**
   * @description Get chat sessions summary
   *
   * @tags logs
   * @name GetSessionLogsSummary
   * @summary Get chat sessions summary
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/logs/sessions-summary
   * @secure
   */
  getSessionLogsSummary = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SessionsSummary,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logs/sessions-summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSessionLogsSummary */
  getSessionLogsSummaryPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format date-time */
      from: string;
      /** @format date-time */
      to?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logs/sessions-summary`, query);

  /**
   * @description Get chat session log
   *
   * @tags logs
   * @name GetSessionLog
   * @summary Get chat session log
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/logs/guest/{guestId}/session/{sessionNum}
   * @secure
   */
  getSessionLog = (
    tenantId: string,
    workspaceId: string,
    guestId: string,
    sessionNum: number,
    params: RequestParams = {},
  ) =>
    this.request<
      SessionLog,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/logs/guest/${guestId}/session/${sessionNum}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSessionLog */
  getSessionLogPathGetter = (tenantId: string, workspaceId: string, guestId: string, sessionNum: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/logs/guest/${guestId}/session/${sessionNum}`);
}
